import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { PageState } from 'app/store/models/page.model';

import { setBannerComponent } from 'app/store/actions/page.action';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss'],
})
export class PartnersComponent implements OnInit {
  constructor(private store: Store<PageState>) {
    this.store.dispatch(setBannerComponent({ banner: 'Partners' }));
  }

  ngOnInit() {}
}
